import { ComponentSelector, ComponentInjector } from '@atypon/ui-utils';
import CoreAdvancedSearchTabular, {
    AdvancedSearchTabularElements,
    AdvancedSearchTabularSelectors,
    AdvancedSearchTabularClassList,
    AdvancedSearchTabularTexts
} from 'ui-core/widgets/advanced-search/js/tabular';
import {
    Inject,
    BrowserUtils
} from '@atypon/ui-utils';

import AdvancedSearchAutoComplete from 'ui-core/widgets/advanced-search/js/autocomplete';

class Texts extends AdvancedSearchTabularTexts { }

class ClassList extends AdvancedSearchTabularClassList { }

class Selectors extends AdvancedSearchTabularSelectors {
}

class Elements extends AdvancedSearchTabularElements {
}

interface AdvancedSearchTabular {
    get elements(): Elements;
    get texts(): Texts;
    get classList(): ClassList;
    get selectors(): Selectors;
}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class AdvancedSearchTabular extends CoreAdvancedSearchTabular {
    isAlternative: HTMLElement[];
    onSearchAreaChange: any;
    constructor(readonly wrapper: HTMLElement, readonly onChanged: (Event) => void) {
        super(wrapper, onChanged)
    }

    @Inject()
    protected browserUtils: BrowserUtils;

    autoCompleteListener: AdvancedSearchAutoComplete;

    /**
     * clone the search in field and set the events
     */
    protected clone(e: Event) {
        e.stopPropagation();
        e.preventDefault();
        const div = document.createElement('div');
        div.innerHTML = this.elements.searchInFieldWrapper[0]?.outerHTML;
        let searchInField = this.domUtils.getElement(this.selectors.searchInFieldWrapper.selector, div);
        let requiredIcon = searchInField.querySelector(".search__required__icon")
        if(requiredIcon){requiredIcon.remove()}
        const clonedInput = searchInField.querySelector('input');
        clonedInput.removeAttribute('value');
        this.wrapper.insertAdjacentElement('beforeend', searchInField);
        this.elements.searchInField = searchInField;
        this.addEventListeners();
        this.toggleButtons();

        const fieldWrapper= this.elements.searchInField;
        const selectFieldWrapper= fieldWrapper?.querySelector('select[id^="searchArea"]') as HTMLElement;
        const clonedSelectInput : HTMLSelectElement = searchInField.querySelector('.advanced-search__search-in__area');
        if(clonedSelectInput?.options?.length){
          clonedSelectInput.options[0].selected = true;
        }
        selectFieldWrapper?.focus();
    }

}

export default AdvancedSearchTabular;